export default __webpack_public_path__ + "60c6d073cfdf57bc03d253196686418d.woff2";